<template>
    <div>
        <b-jumbotron>
            <h1>Referral Affiliate Programme</h1>
            <hr />
            <p>
                Get your friend to sign up and both get free credit in return!
            </p>
            <p v-if="!loading">
                When your friend purchases a plan, you get
                <b>{{site.refererCredit | formatCurrency}}</b
                >. Your friend gets
                <b>{{site.refereeCredit | formatCurrency}}</b> of credit too.
            </p>
        </b-jumbotron>
        <b-jumbotron v-if="loading">
            <Spinner text="Loading" />
        </b-jumbotron>
        <b-jumbotron v-else>
            <div v-if="user.referralCode">
                <p>Your referral code is:</p>
                <h1>{{user.referralCode}}</h1>
                <hr />
                <p>Ask your friend to put this in when registering.</p>
                <b-button size="sm" @click="generate" variant="primary">
                    Reset code
                </b-button>
            </div>
            <div v-else>
                <p>You don't have a referral code yet.</p>
                <b-button size="lg" @click="generate">Generate</b-button>
            </div>
        </b-jumbotron>
    </div>
</template>

<script>
    import { mapState } from 'vuex'

    import axios from '@/services/axios'
    import Spinner from '@/components/general/spinner'

    export default {
        data() {
            return {
                loading: false,
                data: {}
            }
        },
        async created() {
            this.loading = true
            await this.load()
            this.loading = false
        },
        methods: {
            load() {
                this.$store.dispatch('user/user/load')
                this.$store.dispatch('user/site/load')
            },
            async generate() {
                this.loading = true
                await axios
                    .post('user/user/referral')
                    .then(res => {
                        this.$bvToast.toast(res.data, {
                            title: 'Success',
                            variant: 'success'
                        })
                    })
                    .catch(error => {
                        this.$bvToast.toast(error.response.data, {
                            title: 'Error',
                            variant: 'warning'
                        })
                    })
                this.load()
                this.loading = false
            }
        },
        computed: mapState({
            site: state => state.user.site.site,
            user: state => state.user.user.user
        }),
        components: {
            Spinner
        }
    }
</script>